import React from 'react'

import styled, { keyframes } from 'styled-components'

const progressIn = keyframes`
  0% {
    stroke-dasharray: 0,251;
  }
  100% {
    stroke-dasharray: 251,251;
  }
`

const Svg = styled.svg`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
`

const Circle = styled.circle`
  fill: none;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
  animation: ${(p) => p.speed || '10s'} ${progressIn} linear;
`

interface Props {
  size: number
  strokeWidth: number
  speed: string
  color: string
}

export function CircularProgress({ size, strokeWidth, speed, color }: Props) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
    >
      <Circle
        stroke={color}
        speed={speed}
        cx={50}
        cy={50}
        r={40}
        strokeWidth={`${strokeWidth}px`}
      />
    </Svg>
  )
}
